import { ComponentProps } from 'react';
import Select, { components } from 'react-select';
// import { useState } from 'react';
import {
  OptionType,
  GroupedOptionType,
  SelectValue,
} from '@components/shared/forms/Dropdowns/types';
import classnames from 'classnames';
import { CustomIcon } from '@components/shared';
import s from './SaveSearchSelector.module.less';

export type Props = {
  options: Array<OptionType | GroupedOptionType>;
  name: string;
  value?: OptionType;
  onChange: (val: SelectValue) => void;
  isDisabled?: boolean;
  menuPlacement?: ComponentProps<typeof Select>['menuPlacement'];
};

const SaveSearchSelector = ({
  name,
  value,
  onChange,
  options,
  isDisabled = false,
  menuPlacement = 'bottom',
}: Props) => {
  const customStyles = {
    container: base => ({
      ...base,
      display: 'inline-block',
      pointerEvents: 'all',
      width: '210px',
    }),
    menu: base => ({
      ...base,
      cursor: 'pointer',
      minWidth: '210px',
      zIndex: 2,
    }),
  };

  const Option = props => {
    const { children, isSelected, isFocused } = props;
    return (
      <components.Option
        {...props}
        className={classnames(s.option, isSelected && s.selected, isFocused && s.focused)}
      >
        {children}
        {isSelected ? (
          <aside className={s.selectedCheckmark}>
            <CustomIcon type="checkmark" />
          </aside>
        ) : null}
      </components.Option>
    );
  };

  return (
    <Select
      name={name}
      value={value}
      options={options}
      isSearchable={false}
      inputId={name}
      components={{
        Option,
      }}
      styles={customStyles}
      onChange={option => {
        const newValue = option ? option.value : null;
        onChange(newValue);
      }}
      menuPlacement={menuPlacement}
      isDisabled={isDisabled}
    />
  );
};

export default SaveSearchSelector;
